import React from "react";
import { Grid, TextField, MenuItem, Typography, Box, Button } from "@mui/material";
import { Field, FieldArray } from "formik";

export default function ProductVariationsSection({ values, setFieldValue, DeleteProductOption }) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <Field as={TextField} select name="variationType" label="סוג וריאציות" fullWidth>
          <MenuItem value="">ללא</MenuItem>
          <MenuItem value="Color">צבע</MenuItem>
          <MenuItem value="Size">גודל</MenuItem>
        </Field>
      </Grid>

      {values.variationType && (
        <Grid item xs={12}>
          <Typography sx={{ mt: 1, mb: 1, fontWeight: 700 }}>
            אופציות ל-{values.variationType === "Color" ? "צבע" : "גודל"}
          </Typography>

          <FieldArray name="options">
            {({ push, remove }) => (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {(values.options || []).map((opt, idx) => (
                  <Grid container spacing={2} key={idx}>
                    <Grid item xs={12} md={4}>
                      <Field
                        as={TextField}
                        name={`options.${idx}.value`}
                        label={values.variationType === "Color" ? "צבע" : "מידה"}
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Field
                        as={TextField}
                        name={`options.${idx}.extraPrice`}
                        label="מחיר וריאציה"
                        type="number"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} md={2}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => {
                          const optionId = values.options?.[idx]?.id;

                          // מוחקים מייד מה־UI
                          remove(idx);

                          // מוחקים בשרת אם זו אופציה קיימת
                          if (optionId && optionId !== 0) {
                            DeleteProductOption(optionId).catch((err) => console.error("Delete failed", err));
                          }

                          // אם נשאר 0 שורות, נשאיר אחת ריקה
                          const remaining = (values.options || []).length - 1;
                          if (remaining <= 0) {
                            setFieldValue("options", [{ id: 0, value: "", extraPrice: 0, quantity: 0 }]);
                          }
                        }}
                      >
                        מחק
                      </Button>
                    </Grid>
                  </Grid>
                ))}

                <Button
                  variant="contained"
                  onClick={() => push({ id: 0, value: "", extraPrice: 0, quantity: 0 })}
                >
                  הוסף אופציה
                </Button>
              </Box>
            )}
          </FieldArray>
        </Grid>
      )}
    </>
  );
}
